import { push } from "connected-react-router";
import { BASE_URL, APP_VERSION } from "../config/constants";
import { loginWebappPro, checkProAuth } from "./ProApp";

export const logout = () => (dispatch) => {
  dispatch({
    type: "LOGOUT",
  });
  localStorage.clear();
  dispatch(push("/login"));
};

export const fetchAPI = (data) => {
  const { url, fd, token, success, failure, catchFunc } = data;
  return fetch(
    url,
    token
      ? {
          method: "POST",
          body: fd,
          headers: {
            "auth-token": token,
          },
        }
      : { method: "POST", body: fd },
  )
    .then((res) => res.json())
    .then((res) => {
      res.status
        ? success
          ? success(res)
          : console.log(res)
        : failure
          ? failure(res)
          : console.error(res);
    })
    .catch((err) => {
      catchFunc ? catchFunc(err) : console.error(err);
    });
};

export const login = (username, password, app_type) => (dispatch) => {
  let url = BASE_URL + "/apis/login";

  let fd = new FormData();
  fd.append("username", username);
  fd.append("password", password);
  if (app_type === "plusapp" || app_type === "proapp") {
    fd.append("app_version_id", APP_VERSION);
  }

  let success = (res) => {
    const sfa_capabilities = parseInt(res.sfa_capabilities) || 0;
    if (sfa_capabilities === 1 && app_type !== "proapp") {
      dispatch({
        type: "AUTHENTICATION_FAILED",
        payload:
          "This account requires 'Pro App' access. Please select app type as 'Pro App' to continue.",
      });
      return;
    }
    if (sfa_capabilities === 0 && app_type === "proapp") {
      dispatch({
        type: "AUTHENTICATION_FAILED",
        payload: "This account does not have 'Pro App' access.",
      });
      return;
    }
    localStorage.setItem("user_id", res.user_id);
    localStorage.setItem("username", res.username);
    localStorage.setItem("pc_name", res.pc_name);
    localStorage.setItem("token", res.token);
    localStorage.setItem("sfa_capabilities", sfa_capabilities);
    localStorage.setItem("app_type", app_type || "");
    localStorage.setItem("project_uuid", res.project_uuid || "");
    dispatch({
      type: "AUTHENTICATION_SUCCESS",
      payload: { api_token: res.token },
    });
    dispatch({
      type: "SET_USER_DATA",
      payload: {
        user_id: res.user_id,
        username: res.username,
        pc_name: res.pc_name,
        sfa_capabilities,
        app_type: app_type || "",
      },
    });
    if (sfa_capabilities === 1) {
      dispatch(loginWebappPro(username, password));
    }
    dispatch(push("/home"));
  };
  let failure = (res) => {
    dispatch({
      type: "AUTHENTICATION_FAILED",
      payload: res.message,
    });
  };

  fetchAPI({ url, fd, success, failure });
};

export const checkAuth = () => (dispatch) => {
  let url = BASE_URL + "/apis/auth";
  let user_id = localStorage.getItem("user_id");
  let username = localStorage.getItem("username");
  let pc_name = localStorage.getItem("pc_name");
  let token = localStorage.getItem("token");
  let sfa_capabilities =
    parseInt(localStorage.getItem("sfa_capabilities")) || 0;
  let app_type = localStorage.getItem("app_type") || "";

  if (token && user_id) {
    let fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("token", token);
    let success = (res) => {
      dispatch({
        type: "AUTHENTICATION_SUCCESS",
        payload: { api_token: token },
      });
      dispatch({
        type: "SET_USER_DATA",
        payload: { user_id, username, pc_name, sfa_capabilities, app_type },
      });
      if (sfa_capabilities === 1) {
        const pro_auth = JSON.parse(localStorage.getItem("pro_auth"));
        if (pro_auth && pro_auth.pro_token) {
          dispatch(checkProAuth(pro_auth));
        } else {
          dispatch(logout());
        }
      } else {
        dispatch(push("/home"));
      }
    };
    let failure = () => dispatch(logout());

    fetchAPI({ url, token, fd, success, failure });
  } else {
    dispatch(logout());
  }
};
